var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('add-global-widget-dialog',{ref:"addGlobalWidgetDialog",attrs:{"widgets":_vm.widgets},on:{"addWidget":_vm.addWidget}}),_c('widget-form-dialog',{ref:"widgetFormDialog",on:{"submit":_vm.formDialogSubmitted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }